import React from "react"
import Label from '@react/react-spectrum/Label'
import CCLogo from "../../Imgs/CCLogo.png"
import './Header.scss';

export default function Header({title,style,pagename}) {
    return (
        <div className ={style ? "none" : null}>
            <div className="actionTitle">
                <div className="beta"><b>Make your own {title}s</b> <Label variant="grey" id ="grey">Beta</Label></div>
                <p className="actionDesc"> Free from Adobe Creative Cloud <img src={CCLogo} ></img></p>
            </div>            
        </div>
    )
}